
    <div fxLayout="row" fxLayoutAlign="flex-end center" fxLayoutGap="8px">
      <button mat-button (click)="clickLeft.emit()">
        {{ buttonLeft | translate | uppercase }}
      </button>

      <button
        mat-flat-button
        color="primary"
        [disabled]="disable"
        (click)="clickRight.emit()"
      >
        {{ buttonRight | translate | uppercase }}
      </button>
    </div>
  